/**
 * User labels
 * Dynamic mapping from JSON based on current language
 * Uses getLanguage() to determine which locale to use
 */

import svUser from '../locales/sv/user.json';
import enUser from '../locales/en/user.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

/**
 * Helper function to get the correct locale based on language
 */
const getUserLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enUser : svUser;
};

/**
 * User labels - dynamically uses current language
 */
export const userLabels = (lang?: Language): Record<string, any> => {
  const locale = getUserLocale(lang);
  return locale;
};

